
    export default 
    {
    "market": {
        "placeholder": "Inserisci le parole chiave per effettuare la ricerca",
        "import_to_dsers": "importa su DSers",
        "import_tip_title": "Seleziona i negozi per importare i prodotti"
    }
}